import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const SCRAPING_REVIEW_COMMENTS_QUERY = gql`
  query scrapingReviewComments($id: ID!) {
    scrapingReviewComments(id: $id) {
      id
      type
      text
      user {
        ...SimpleUserFragment
      }
      createdAt
    }
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default SCRAPING_REVIEW_COMMENTS_QUERY
